import { render, staticRenderFns } from "./voucher.vue?vue&type=template&id=6e22b099"
import script from "./voucher.vue?vue&type=script&lang=js"
export * from "./voucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports